import * as posthogModule from 'posthog-js'

const posthog = posthogModule.default || posthogModule

export default defineNuxtPlugin((_nuxtApp) => {
  const router = useRouter()

  const config = useRuntimeConfig()

  // PostHog initialization
  const posthogKey = config.public.posthogKey as string | undefined
  const posthogHost = config.public.posthogHost as string | undefined

  if (posthogKey && posthogHost) {
    posthog.init(posthogKey, {
      api_host: posthogHost,
      person_profiles: 'identified_only'
    })

    router.afterEach((to) => {
      nextTick(() => {
        posthog.capture('$pageview', {
          current_url: to.fullPath
        })
      })
    })
  }

  return {
    provide: {
      posthog: posthogKey && posthogHost ? posthog : null
    }
  }
})
